/**
 * Assigns stable option codes (`a`…`z`, then `aa`…) to options missing `code`.
 * Existing non-empty codes are preserved (safe for re-save / ActionLog identity).
 */
export function indexToOptionCode(index: number): string {
  let i = index;
  let result = "";
  while (true) {
    result = String.fromCharCode(97 + (i % 26)) + result;
    i = Math.floor(i / 26) - 1;
    if (i < 0) break;
  }
  return result;
}

export function nextOptionCode(used: Set<string>): string {
  for (let i = 0; ; i++) {
    const code = indexToOptionCode(i);
    if (!used.has(code)) {
      return code;
    }
  }
}

type OptionWithCode = { code?: string };

export function assignOptionCodes<T extends OptionWithCode>(options: T[]): T[] {
  const used = new Set<string>();
  for (const option of options) {
    if (typeof option.code === "string" && option.code.trim().length > 0) {
      used.add(option.code);
    }
  }

  return options.map((option) => {
    if (typeof option.code === "string" && option.code.trim().length > 0) {
      return option;
    }
    const code = nextOptionCode(used);
    used.add(code);
    return { ...option, code };
  });
}
